module.exports = __webpack_public_path__ + "img/guincho.550af6af.svg";